'use client';
import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useCollapsibleContext } from './collapsible.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[t] = r, e;
}
function _object_spread(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = null != arguments[t] ? arguments[t] : {}, o = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), o.forEach(function(t) {
            _define_property(e, t, r[t]);
        });
    }
    return e;
}
function ownKeys(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r.push.apply(r, o);
    }
    return r;
}
function _object_spread_props(e, t) {
    return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    }), e;
}
const CollapsibleContent = renderWithRef('CollapsibleContent', null, (o, p)=>{
    let { id: i } = o, l = useId(i), { setContentId: s, expanded: a } = useCollapsibleContext();
    useEffect(()=>(s(l), ()=>s(void 0)), [
        l,
        s
    ]);
    let b = new Set([
        'swan-collapsible-content'
    ]);
    return a && b.add('swan-collapsible-content-open'), jsx(RenderComp, {
        root: "div",
        forwardedRef: p,
        classNames: b,
        props: _object_spread_props(_object_spread({}, o), {
            id: l
        }),
        children: o.children
    });
});

export { CollapsibleContent };
